import React, { Component } from 'react';
import { observer } from 'mobx-react';
import autoBindMethods from 'class-autobind-decorator';

import { DropdownButton, MenuItem } from 'react-bootstrap';

import { Icon } from '../../common';

interface IProps {
  contactId: string;
  onEdit: (contactId: string) => void;
  onRemove: (contactId: string) => void;
}

/**
 * c.f. the case contacts table's row dropdown, less its tracking contact item -- an account has no
 * tracking contact. Remove takes the contact off this account and leaves the contact itself alone,
 * for the same reason removing one from a case does: it may be on other accounts, and it stays in the
 * funder's contacts either way for the add flow to find again.
 */
@autoBindMethods
@observer
class ContactRowDropdown extends Component<IProps> {
  private onEdit () {
    this.props.onEdit(this.props.contactId);
  }

  private onRemove () {
    this.props.onRemove(this.props.contactId);
  }

  public render () {
    return (
      <div className='dropdown-arrow right text-center'>
        <DropdownButton
          bsStyle='link'
          id={`contact-row-dropdown-${this.props.contactId}`}
          noCaret
          pullRight
          title={<Icon type='ellipsis-v' />}
        >
          <MenuItem className='menu-item-edit-contact' eventKey='edit' onSelect={this.onEdit}>
            <Icon type='pencil' /> Edit
          </MenuItem>
          <MenuItem className='menu-item-remove-contact' eventKey='remove' onSelect={this.onRemove}>
            <Icon type='trash' /> Remove
          </MenuItem>
        </DropdownButton>
      </div>
    );
  }
}

export default ContactRowDropdown;
